module.exports = __webpack_public_path__ + "static/media/public-sector-landscape.c96acac6.jpg";